/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        setTimeout(function(){
            $('.el-a, .el-u').addClass('animate-1');
            $('.dismiss-loader').fadeIn('slow');
        }, 1200); 
        setTimeout(function(){
            $('.el-u').addClass('animate-2');
        }, 2200);
        
        setTimeout(function(){
            $('.el-sm_circle').addClass('animate-4');
        }, 2700);
        setTimeout(function(){
            $('.el-line').addClass('animate-3');
        }, 3500);
        setTimeout(function(){
            $('.el-a').addClass('animate-4');
            $('.el-sm_circle').addClass('animate-5');
            $('.el-u').addClass('animate-5');
            $('.el-lg_circle').addClass('animate-4');
        }, 4200);
        
        setTimeout(function(){
            $('.loader').fadeOut();
        }, 6000);       
          
        setTimeout(function(){
            // ScrollReveal
            window.sr = ScrollReveal({ reset: false });
            sr.reveal('.fadein', {
                duration   : 500,
                scale      : 1,
                distance   : '20px',
                origin     : 'bottom',
                reset      : false,
                easing     : 'ease-out', 
                viewFactor : 0.5 
            });
        }, 5500); 

        $('.dismiss-loader').on('click', function() {
            $('.loader').fadeOut();
        });
          
        $('.hamburger-menu').on('click', function() {
            $('.bar').toggleClass('animate');
            $('.nav-primary').toggleClass('active');
        });
          
        // MENU ACTION
        $('.banner .nav-primary .nav li a').on('click', function() {
            $('.bar').toggleClass('animate');
            $('.nav-primary').toggleClass('active');
        });
        
        // NAV STICKY
        $(document).on("scroll", function() { 
            if($(document).scrollTop()>500) {
                $(".banner").addClass("sticky");
            } else {
                $(".banner").removeClass("sticky");
            }
        });      
          
        // SCROLL ANCHORS
        $('.qore-nav li a').click(function(){
            $('html, body').animate({
                scrollTop: $( $.attr(this, 'href') ).offset().top - 60
            }, 800);
            return false;
        });
                  
          
          
        // Parallax Functino
        function parallax() {
            var start = null;
            var scrollPosition = window.scrollY;
            var halfWindowHeight = window.innerHeight / 2;
            var rAFstarted = false;
            var scrollnimates = [].slice.call(document.getElementsByClassName('parallax-item'));
            scrollnimates.forEach(function (sn) {
                var clientOffsets = sn.getBoundingClientRect();
                sn.animationOffset = clientOffsets.top + scrollPosition;
                sn.magicNumber = sn.dataset.magicNumber || sn.getAttribute("data-scroll") || "-14";
            });
            function step(timestamp) {
                if (!start) start = timestamp;
                var progress = timestamp - start;
                var scrollPoint = window.scrollY;
                scrollnimates.forEach(function (sn) {
                    if (scrollPoint > (sn.animationOffset - halfWindowHeight * 2) && scrollPoint < (sn.animationOffset + halfWindowHeight)) {
                        var magicPoint = (scrollPoint - (sn.animationOffset - halfWindowHeight)) / sn.magicNumber;
                        var up = magicPoint + 'px';
                        sn.style.webkitTransform = 'translateY(' + up + ')';
                        sn.style.MozTransform = 'translateY(' + up + ')';
                        sn.style.msTransform = 'translateY(' + up + ')';
                        sn.style.OTransform = 'translateY(' + up + ')';
                        sn.style.transform = 'translateY(' + up + ')';
                    }
                });
                window.requestAnimationFrame(step);
            }
            window.requestAnimationFrame(step);
        }          
        parallax();  
          
          
          
        // INVIEW Functions
        function inView( opt ) {
            if( opt.selector === undefined ) {
                console.log( 'Valid selector required for inView' );
                return false;
            }
            var elems = [].slice.call( document.querySelectorAll( opt.selector ) ),
                once = opt.once === undefined ? true : opt.once,
                offsetTop = opt.offsetTop === undefined ? 0 : opt.offsetTop,
                offsetBot = opt.offsetBot === undefined ? 0 : opt.offsetBot,
                count = elems.length,
                winHeight = 0,
                ticking = false;
            function update() {
                var i = count;
                while( i-- ) {
                    var elem = elems[ i ],
                        rect = elem.getBoundingClientRect();
                    if( rect.bottom >= offsetTop && rect.top <= winHeight - offsetBot ) {
                        elem.classList.add( 'in-view' );
                        if( once ) {
                            count--;
                            elems.splice( i, 1 );
                        }
                    } else {
                        elem.classList.remove( 'in-view' );
                    }
                }
                ticking = false;
            }
            function onResize() {
                winHeight = window.innerHeight;
                requestTick();
            }
            function onScroll() {
                requestTick();
            }
            function requestTick() {
                if( !ticking ) {
                    requestAnimationFrame( update );
                    ticking = true;
                }
            }
            window.addEventListener( 'resize', onResize, false );
            document.addEventListener( 'scroll', onScroll, false );
            document.addEventListener( 'touchmove', onScroll, false );
            onResize();
        }
        // InView
        inView({
            selector: '.inview-item', // an .in-view class will get toggled on these elements
            once: false, // set this to false to have the .in-view class be toggled on AND off
            offsetTop: 0, // top threshold to be considered "in view"
            offsetBot: 200 // bottom threshold to be considered "in view"
        });          
          
        // NAV STICKY
          /*
        $(document).on("scroll", function() { 
            var this_id = $('section.in-view').attr('id');
            var active_link = $('.banner .nav-primary ul li a.link-'+this_id);
            if($('section').hasClass('in-view')) {
                active_link.addClass('active');
            }  {
                // active_link.removeClass('active');
            } 
        }); 
        */
          
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
